<template>
	<div>
		<a-form-model  ref="addForm"  :model="addModel"   :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :rules="rules" >
			<a-form-model-item label="所属小区" prop="neighborId">
				<a-select v-model="addModel.neighborId" allowClear option-filter-prop="children"  :filter-option="filterOption" show-search>
					<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="采集器地址" prop="collectorAddr">
				<a-input  v-model="addModel.collectorAddr"/>
			</a-form-model-item>
			<a-form-model-item label="IMEI" prop="imei">
				<a-input  v-model="addModel.imei"/>
			</a-form-model-item>
			<a-form-model-item label="IMSI" prop="imsi">
				<a-input  v-model="addModel.imsi"/>
			</a-form-model-item>
			<a-form-model-item label="所属平台" prop="platform">
				<a-select v-model="addModel.platform">
					<a-select-option v-for="(item,index) in platformList" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="是否大表" prop="mainMeter">
				 <a-switch  v-model = "addModel.mainMeter=='1'"  @change="changeMainMeter"/>
			</a-form-model-item>
			<a-form-model-item label="备注信息" prop="remark">
				<a-textarea :rows="6" placeholder="最多300字" :max-length="300" v-model="addModel.remark"/>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'neighborList',
		],
		data(){
			return {
				addModel:{
					platform:null,
					neighborId:null,
					collectorAddr:null,
					imei:null,
					imsi:null,
					remark:null,
					mainMeter:'0',
				},
				submitFlag:false,
				rules:{
					neighborId:[{required:true,message:'请选择小区',trigger: 'blur'},],
					collectorAddr:[{required:true,message:'请输入采集器地址',trigger: 'blur'}],
					imei:[{required:true,message:'请输入IMEI',trigger: 'blur'}],
					platform:[{required:true,message:'请选择平台',trigger: 'blur'}],
				}, 
				platformList:[
					{
						label:"AEP",
						value:"0"
					},
					{
						label:"OneNet",
						value:"1"
					},
				]
			}
		},
		methods:{
			changeMainMeter:function(checked,e){
				this.addModel.mainMeter = checked ? '1' : '0';
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			onClose:function(flag){
				this.$emit('cancelAdd');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.ADD_NB_COLLECTOR_URL);
				this.Api.fetchPostWithForm(url,this.addModel).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
						this.$message.success('新增NB采集器成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				})
			},
		}
	}
</script>

<style>
</style>
